import { ScheduleCalendarStore } from "@lib/store/src/scheduleCalendar";
import { UiFloatModal } from "../../../common/modal";
import { HolidayCalendarEventName, HolidaysCalendar, HolidaysCalendarConfirmEvent } from "../../components/holidaysCalendar/holidaysCalendar";
import { MsScheduleApi } from "@lib/api";

// Side effect import to define custom element.
// eslint-disable-next-line no-duplicate-imports
import "../../components/holidaysCalendar/holidaysCalendar";

/** Custom holidays modal. */
export class HolidaysModal {

    /** Popup instance. */
    public readonly popup: UiFloatModal;

    private readonly calendar: HolidaysCalendar;

    private readonly store: ScheduleCalendarStore;

    private readonly api: MsScheduleApi;

    public constructor(store: ScheduleCalendarStore, api: MsScheduleApi) {
        this.store = store;
        this.api = api;
        try {
            this.popup = new UiFloatModal("<holidays-calendar class=\"calendar\"></-calendar>");
            this.popup.modalComponent.x = 10;
            this.popup.modalComponent.y = 10;
            this.popup.modalComponent.width = 900;

            const calendar = this.popup.modalComponent.querySelector<HolidaysCalendar>(".calendar");

            if (calendar === null) {
                throw new Error("Could not find schedule form element.");
            }

            this.calendar = calendar;

            this.calendar.addEventListener(HolidayCalendarEventName.Cancel, this.handleCancel.bind(this));
            this.calendar.addEventListener(HolidayCalendarEventName.Confirm, this.handleConfirm.bind(this));

        } catch(e) {
            console.error("Error <initPopup> >> ", e);
        }
    }

    /** Opens modal. */
    public open(): void {
        this.calendar.holidayExceptionDates = this.store.holidayExceptions;
        this.calendar.resetCalendarSelectedDates();
        this.popup.modalComponent.open();
    }

    /** Closes modal. */
    public close(): void {
        this.popup.modalComponent.close();
    }

    private handleCancel(): void {
        this.close();
    }

    private handleConfirm(event: HolidaysCalendarConfirmEvent): void {
        this.store.onChange("holidayExceptions", event.detail);
        void this.api.setExceptionDates(event.detail);
        this.close();
    }
}
